import { Injectable } from '@angular/core';
import { ActionItemSearch } from '../models/action-item-search';
import { HttpClient } from '@angular/common/http';
import { Observable, of, share, tap } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';
import { ScopeLookup } from '../../change-control/change-control-library/models/scope-lookup';
import { ActionItemLookUp } from '../../change-control/change-control-details/models/action-item-lookup';

@Injectable({
  providedIn: 'root'
})
export class ActionItemRegisterService {
  actionItemLookUp: ActionItemLookUp | null = null;
  userList = [];
  userListObservable!: Observable<any>;

  constructor(private httpClient: HttpClient) { }

  actionItemAuthorization(): Observable<any> {
    return this.httpClient.get(ApiConstants.ActionItemRegister_Authorize_Api);
  }

  getActionItemSearch(actionItemSearchData: ActionItemSearch): Observable<any> {
    return this.httpClient.post(ApiConstants.ActionItemRegister_Search_Api, actionItemSearchData);
  }

  getScopesForActionItem(): Observable<ScopeLookup[]> {
    return this.httpClient.get<ScopeLookup[]>(ApiConstants.ActionItem_Scopes_Api);
  }

  getusers(): Observable<any> {
    let observable: Observable<any>;
    if (this.userList.length > 0) {
      observable = of(this.userList);
    } else if (this.userListObservable) {
      observable = this.userListObservable;
    }
    else {
      this.userListObservable = this.httpClient.get<any>(ApiConstants.ActionItem_Users_Api)
        .pipe(
          tap(userData => this.userList = userData),
          share()
        );
      observable = this.userListObservable;
    }
    return observable;
  }

  getActionItemLookUpDetails(): Observable<ActionItemLookUp> {
    //If the Data is not available then we make an API call
    if (!this.actionItemLookUp || this.isLookUpDataEmpty(this.actionItemLookUp)) {
      return this.httpClient
        .get<ActionItemLookUp>(ApiConstants.ActionItem_LookUpDetails_Api)
        .pipe(tap((lookUpData) => (this.actionItemLookUp = lookUpData)));
    } else {
      //If data is available directly we return the data
      return of(this.actionItemLookUp);
    }
  }

  private isLookUpDataEmpty(lookUpData: ActionItemLookUp): boolean {
    return Object.values(lookUpData).every(array => Array.isArray(array) && array.length === 0);
  }

}
